module.exports = fox._r("flash/WCamResolutionInspector.swf", __webpack_public_path__ + "_/_/_/common/frame/flash/WCamResolutionInspector.swf");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/flash/WCamResolutionInspector.swf
// module id = 212
// module chunks = 2